import { createSelector } from 'reselect';

export const ContactSelector = (state) => state.contacts;

export const getContacts = createSelector(
    [ContactSelector],
    (state) => state.contacts
);
